import * as React from 'react';
import clsx from 'clsx';
import Heading from 'components/text/Heading';

import {
  AccordionContent,
  AccordionTrigger,
  Accordion as RAccordion,
  AccordionItem as RAccordionItem
} from './@radix-styled/Accordion';

export interface IAccordionItem {
  title: string;
  children: React.ReactNode;
}

interface Props {
  title?: string;
  items: Array<IAccordionItem>;
  className?: string;
  accordionItemClassName?: string;
  accordionTitleClassName?: string;
  accordionItemContentClassName?: string;
  headingClassName?: string;
}

const Accordion: React.FC<Props> = ({
  title,
  items,
  className,
  headingClassName,
  accordionItemClassName,
  accordionTitleClassName,
  accordionItemContentClassName
}) => {
  return (
    <div className={clsx('Accordion', className)}>
      {title && (
        <Heading variant="h2" className={clsx('mb-4', headingClassName)}>
          {title}
        </Heading>
      )}
      <RAccordion type="multiple">
        {items.map((item, i) => (
          <RAccordionItem
            value={`accordion-item-${i}`}
            key={`accordion-item-${i}`}
            className={clsx(accordionItemClassName)}
          >
            <AccordionTrigger className="text-left hover:no-underline">
              <Heading variant="h4" className={clsx(accordionTitleClassName)}>
                {item.title}
              </Heading>
            </AccordionTrigger>
            <AccordionContent
              className={clsx(
                'prose prose-neutral max-w-[calc(100%-36px)]',
                accordionItemContentClassName
              )}
            >
              {item.children}
            </AccordionContent>
          </RAccordionItem>
        ))}
      </RAccordion>
    </div>
  );
};

Accordion.displayName = 'Accordion';

export default Accordion;
